import { Box } from "@mui/material";
import { useDynamicHeight } from "@hooks/use-dynamic-height";
import { PropsWithChildren } from "react";

/** The top padding for the projects map, in pixels */
const PROJECTS_MAP_TOP_PADDING = 16;

/**
 * Container for the projects map that sets the correct height for the map.
 */
export function ProjectsMapContainer({ children }: PropsWithChildren): JSX.Element {
  const { ref, height } = useDynamicHeight();

  return (
    <Box
      ref={ref}
      component="div"
      data-testid="projects-map-container"
      sx={{
        width: "100%",
        height,
        marginTop: `${PROJECTS_MAP_TOP_PADDING}px`,
      }}
    >
      {children}
    </Box>
  );
}
